import { Box, Card, CardContent, Typography } from "@mui/material";

import { i18n } from "services/i18nService";

const sx = {
  display: "grid",
  minWidth: "1070px",
  "& a": { color: "primaryLink" },
};

const divStyles = { marginBottom: "1.5rem" };

export function WhatsNew() {
  return (
    <>
      <Box sx={sx} m={2} mb={0}>
        <Box mb={1}>
          <Typography variant="h2">{i18n("whatsNew.WhatsNew")}</Typography>
        </Box>
        <Card variant="outlined" sx={{ maxWidth: 750, mb: 2 }}>
          <CardContent>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.9.0.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.9.0.1")}</li>
                <li>{i18n("whatsNew.9.0.2")}</li>
                <li>{i18n("whatsNew.9.0.3")}</li>
                <li>{i18n("whatsNew.9.0.4")}</li>
                <li>{i18n("whatsNew.9.0.5")}</li>
                <li>{i18n("whatsNew.9.0.6")}</li>
                <li>{i18n("whatsNew.9.0.7")}</li>
                <li>{i18n("whatsNew.9.0.8")}</li>
                <li>{i18n("whatsNew.9.0.9")}</li>
                <li>{i18n("whatsNew.9.0.10")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.16.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.16.1")}</li>
                <li>{i18n("whatsNew.8.16.2")}</li>
                <li>{i18n("whatsNew.8.16.3")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.15.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.15.1")}</li>
                <li>{i18n("whatsNew.8.15.2")}</li>
                <li>{i18n("whatsNew.8.15.3")}</li>
                <li>{i18n("whatsNew.8.15.4")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.14.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.14.1")}</li>
                <li>{i18n("whatsNew.8.14.2")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.13.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.13.1")}</li>
                <li>{i18n("whatsNew.8.13.2")}</li>
                <li>{i18n("whatsNew.8.13.3")}</li>
                <li>{i18n("whatsNew.8.13.4")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.12.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.12.1")}</li>
                <li>{i18n("whatsNew.8.12.2")}</li>
                <li>{i18n("whatsNew.8.12.3")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.11.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.11.1")}</li>
                <li>{i18n("whatsNew.8.11.2")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.10.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.10.1")}</li>
                <li>{i18n("whatsNew.8.10.2")}</li>
                <li>{i18n("whatsNew.8.10.3")}</li>
              </ul>
            </div>
            <div style={divStyles}>
              <Typography variant="h4">
                {i18n("whatsNew.8.9.header")}
              </Typography>
              <ul>
                <li>{i18n("whatsNew.8.9.1")}</li>
                <li>{i18n("whatsNew.8.9.2")}</li>
                <li>{i18n("whatsNew.8.9.3")}</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
